export const lookInsideImages = [
  {
    src: 'https://cdn.magicpatterns.com/uploads/v7jbG14epgUdKWtkogRQCg/IMG_2551.jpg',
    alt: 'Sample page: 6.4 Explaining Abstract Electrical Concepts, using the water pipe analogy',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/frPJBnUXUKZeYMdnUqHtpZ/IMG_2552.jpg',
    alt: 'Sample page: 6.9 Adapting to Different Educational Levels',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/ipPeu6HFT73M3yYTNNJRzk/IMG_2553.jpg',
    alt: 'Sample page: 2.8 SI Units for Electrical Quantities',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/8QWJ3ALbQ7uqXWCs4BRANt/IMG_2554.jpg',
    alt: 'Sample page: Where Electrical Engineering Appears',
  },
  {
    src: 'https://cdn.magicpatterns.com/uploads/9sQzraHogsSVopaeCy9W5e/IMG_2555.jpg',
    alt: 'Sample page: Chapter 1 — Introduction to Electrical Engineering',
  },
];
